import { UploadFile } from 'antd';
import { UploadChunkResponse, UploadChunksCompletedResponse, UploadImageResponse } from '../type';
import { RcFile } from 'antd/es/upload';
import { httpRequest } from '../../../core';
import { HttpMethod, Nullable } from '../../../core/type';

export class UploaderService {
  uploadImages(files: UploadFile[]): Promise<UploadImageResponse[]> {
    const data = new FormData();
    files.forEach(file => data.append('images', file as RcFile));

    return httpRequest.execute<UploadImageResponse[]>({
      method: HttpMethod.POST,
      url: 'files/image',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      body: data
    });
  }

  uploadPdfFiles(files: UploadFile[]): Promise<UploadImageResponse[]> {
    const data = new FormData();
    files.forEach(file => data.append('files', file as RcFile));

    return httpRequest.execute<UploadImageResponse[]>({
      method: HttpMethod.POST,
      url: 'files/pdf',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      body: data
    });
  }

  uploadVideoFiles(files: UploadFile[]): Promise<UploadImageResponse[]> {
    const data = new FormData();
    files.forEach(file => data.append('videos', file as RcFile));

    return httpRequest.execute<UploadImageResponse[]>({
      method: HttpMethod.POST,
      url: 'files/video',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      body: data,
    });
  }

  async uploadChunks(
    file: RcFile,
    onChunkUploaded: (res: UploadChunkResponse) => void,
  ): Promise<string> {
    const chunkSize = 1024 * 1024
    const totalChunks = Math.ceil(file.size / chunkSize)

    const uploadChunk = (chunk: Blob, currentChunk: number, uploadId?: string) => {
      const data = new FormData()
      data.append('files', chunk, file.name)
      data.append('totalChunks', totalChunks.toString())
      data.append('currentChunk', currentChunk.toString())

      if (uploadId)
        data.append('uploadId', uploadId)

      return httpRequest.execute<Nullable<UploadChunksCompletedResponse>>({
        method: HttpMethod.POST,
        url: 'files/chunk',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        body: data,
      })
    }

    let startByte = 0
    let uploadId: string = ''

    for (let i = 1; i <= totalChunks; i++) {
      const endByte = Math.min(startByte + chunkSize, file.size)
      const chunk = file.slice(startByte, endByte)
      const res = await uploadChunk(chunk, i, uploadId)
      uploadId = res?.uploadId ?? ''

      onChunkUploaded({
        percentage: Math.round((i * 100) / totalChunks),
      })
      startByte = endByte
    }

    return uploadId
  }

  extract(directoryId: string) {
    return httpRequest.execute<void>({
      method: HttpMethod.POST,
      url: `files/${directoryId}/extract`,
    })
  }

  downloadPdfUrl(fileName: string): string {
    return `${httpRequest.baseURL}/files/pdf/${fileName}`
  }
}
